// extracted by mini-css-extract-plugin
export default {"templateList":"SelectTemplateModalUI_templateList__yPS6M"};